(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["easylonger-rewards-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('el-rewards-estimate')) {
    let dialogSequence = 0;
    customElements.define('el-rewards-estimate', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.setupDialog(options);
        if (this.dataset.context !== 'product') return;
        try { this.config = JSON.parse(this.querySelector('[data-el-rewards-product]')?.textContent || '{}'); } catch { return; }
        this.form = this.closest('form');
        this.valueNode = this.querySelector('[data-el-rewards-value]');
        this.noteNode = this.querySelector('[data-el-rewards-note]');
        if (!this.form || !this.valueNode || !this.noteNode) return;
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        ['input', 'change', 'click', 'variant:change'].forEach(name => this.form.addEventListener(name, schedule, options));
        document.addEventListener('easylonger:camping-change', schedule, options);
        window.addEventListener('pageshow', schedule, options);
        this.update();
      }
      setupDialog(options) {
        const trigger = this.querySelector('[data-el-rewards-open]');
        const dialog = this.querySelector('[data-el-rewards-dialog]');
        const close = this.querySelector('[data-el-rewards-close]');
        if (!trigger || !dialog || !close || typeof dialog.showModal !== 'function') return;
        this.dialog = dialog;
        if (!dialog.id) dialog.id = 'el-rewards-dialog-' + (++dialogSequence);
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        const open = event => {
          event.preventDefault();
          if (dialog.open) return;
          const drawer = this.closest('cart-drawer[open]');
          const trap = drawer?.focusTrap;
          if (trap?.active && !trap.paused) {
            trap.pause();
            this.pausedTrap = trap;
            this.trapOwner = drawer;
          }
          try { dialog.showModal(); } catch { this.releaseDialog(); return; }
          this.dialogKeys = new AbortController();
          window.addEventListener('keydown', event => {
            if (!dialog.open || (event.key !== 'Tab' && event.key !== 'Escape')) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            if (event.key === 'Escape') dialog.close();
            else close.focus({ preventScroll: true });
          }, { capture: true, signal: this.dialogKeys.signal });
          close.focus({ preventScroll: true });
        };
        trigger.addEventListener('click', open, options);
        trigger.addEventListener('keydown', event => { if (event.key === ' ') open(event); }, options);
        close.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close(); }, options);
        dialog.addEventListener('keydown', event => { if (event.key === 'Escape') event.stopPropagation(); }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.releaseDialog();
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        }, options);
      }
      releaseDialog() {
        this.dialogKeys?.abort();
        this.dialogKeys = null;
        const trap = this.pausedTrap;
        const owner = this.trapOwner;
        this.pausedTrap = null;
        this.trapOwner = null;
        if (trap?.active && owner?.isConnected && owner.open) trap.unpause();
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.releaseDialog();
        this.controller = null;
        cancelAnimationFrame(this.frame);
      }
      update() {
        const id = this.form.elements.namedItem('id')?.value || this.config.selected;
        const selected = this.config.variants?.find(variant => String(variant.id) === String(id));
        const quantityField = this.form.elements.namedItem('quantity');
        const quantity = quantityField ? Number(quantityField.value) : 1;
        const sellingPlan = this.form.elements.namedItem('selling_plan')?.value;
        const eligible = this.config.eligible && selected?.available && !selected.components && !sellingPlan && Number.isSafeInteger(selected.price) && selected.price >= 0 && Number.isSafeInteger(quantity) && quantity > 0;
        let label = this.config.fallback;
        let note = this.config.terms;
        if (eligible) {
          const taxAdjustment = Boolean(this.config.taxIncluded && selected.taxable);
          if (taxAdjustment) note = this.config.taxTerms;
          const offer = window.ELCampingOffer;
          const offerActive = Boolean(offer?.applies(this.config.handle, selected.id));
          const cents = offerActive ? offer.total(selected.price, quantity) : selected.price * quantity;
          if (Number.isSafeInteger(cents) && cents >= 0) {
            const points = Math.floor(cents * 2 / 100);
            const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { maximumFractionDigits: 0 }).format(points);
            label = this.config.label.replace('__points__', formatted);
            if (offerActive) note = taxAdjustment ? this.config.offerTaxTerms : this.config.offerTerms;
          }
        }
        if (this.valueNode.textContent !== label) this.valueNode.textContent = label;
        if (this.noteNode.textContent !== note) this.noteNode.textContent = note;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
